module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JkJ66c/tc-custom/9781429935814.jpg?1737767946692",
      "alt": "This image is the cover for the book Interesting Times"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Interesting Times\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The renowned journalist charts the chaotic years between 9/11 and Obama’s first presidential campaign in this National Book Award–winning collection.")]), _c('br'), _c('br'), _vm._v("Throughout his career as a journalist, George Packer has always been attuned to the voices and stories of individuals caught up in the big ideas and events of contemporary history. "), _c('i', [_vm._v("Interesting Times ")]), _vm._v("unites brilliant investigative pieces such as “Betrayed,” about Iraqi interpreters, with personal essays and detailed narratives of travels through war zones and failed states."), _c('br'), _c('br'), _vm._v("Spanning the first decade of the 21st century, Packer brings insight and passion to his accounts of the war on terror, Iraq, political writers, and the 2008 election. Across these varied subjects a few key themes recur: the temptations and dangers of idealism; the moral complexities of war and politics; the American capacity for self-blinding and self-renewal."), _c('br'), _c('br'), _vm._v("Whether exploring American foreign policy, tracking a used T-shirt from New York to Uganda, or describing the ambivalent response in Appalachia to Obama, these essays hold a mirror up to our own troubled times and showcase Packer’s unmistakable perspective, which is at once both wide-angled and humane.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George Packer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus and Giroux\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0